export default function isEmptyObject(obj: {[key: string]: any}): boolean {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object
}
